import { useQuery } from '@tanstack/react-query';

import { getAccountIdBySalesforceId } from '~/services/ContractingService';

import { accountQueryKeys } from './accountQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetContractingAccountId(salesforceAccountId: string | undefined) {
  return useQuery({
    queryKey: accountQueryKeys.bySalesforceId(salesforceAccountId ?? ''),
    queryFn: ({ signal }) => getAccountIdBySalesforceId(salesforceAccountId ?? '', { signal }),
    enabled: !!salesforceAccountId,
    staleTime: Infinity,
    retry: retryUnlessRejected,
  });
}
